const svgModules = import.meta.glob('../../svg/**/*.svg', { eager: true, query: '?raw', import: 'default' });

class Svg {
    constructor(name) {
        let div = document.createElement('div');
        const matchingKey = Object.keys(svgModules).find(k => k.endsWith('/' + name + '.svg'));
        div.innerHTML = matchingKey ? svgModules[matchingKey] : '';

        let fragment = document.createDocumentFragment();
        fragment.appendChild(div);

        this.svg = fragment.querySelector('svg');
    }

    classes(classes) {
        if (classes) {
            this.svg.classList = '';
            
            classes.split(' ').forEach(className => {
                this.svg.classList.add(className);
            });
        }

        return this;
    }

    width(width) {
        if (width) {
            this.svg.setAttribute('width', width);
        }

        return this;
    }

    height(height) {
        if (height) {
            this.svg.setAttribute('height', height);
        }

        return this;
    }

    toString() {
        return this.svg.outerHTML;
    }
}

export default {
    props: ['name', 'classes', 'width', 'height'],

    render(h) {
        return h('div', {
            domProps: {
                classList: 'flex items-center',
                innerHTML: new Svg(this.name)
                    .classes(this.classes)
                    .width(this.width)
                    .height(this.height)
            }
        });
    }
};